import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import { Redirect } from 'react-router-dom';

// this is a hack to refresh the page
export const Refresh = ({ location }) => <Redirect to={location.state.to} />;

Refresh.propTypes = {
  location:     ReactRouterPropTypes.location.isRequired,
};

export default Refresh;



// WEBPACK FOOTER //
// ./src/components/Refresh.jsx